import type { GreffierBriefingStructured } from "@/types/personas";

export function parseGreffierBriefing(
  raw: unknown,
): GreffierBriefingStructured | null {
  if (raw === null || raw === undefined || raw === "") return null;
  if (typeof raw === "object" && !Array.isArray(raw)) {
    return raw as GreffierBriefingStructured;
  }
  const text = typeof raw === "string" ? raw : String(raw);
  try {
    const parsed = JSON.parse(text);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as GreffierBriefingStructured;
    }
    return { acte_1: text };
  } catch {
    return { acte_1: text };
  }
}
